var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneInTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3761_99857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3761_99857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 9.95703C15.8333 8.33203 15.2672 6.95342 14.135 5.8212C13.0033 4.68953 11.625 4.1237 10 4.1237V2.45703C11.0417 2.45703 12.0175 2.65481 12.9275 3.05036C13.8369 3.44648 14.6286 3.98148 15.3025 4.65536C15.9758 5.3287 16.5106 6.12036 16.9067 7.03036C17.3022 7.93981 17.5 8.91536 17.5 9.95703H15.8333ZM12.5 9.95703C12.5 9.26259 12.2569 8.67231 11.7708 8.1862C11.2847 7.70009 10.6944 7.45703 10 7.45703V5.79036C11.1528 5.79036 12.1356 6.19648 12.9483 7.0087C13.7606 7.82148 14.1667 8.80425 14.1667 9.95703H12.5ZM16.625 17.4987C14.8333 17.4987 13.0869 17.0993 11.3858 16.3004C9.68417 15.502 8.17722 14.4465 6.865 13.1337C5.55222 11.8215 4.49667 10.3145 3.69833 8.61286C2.89944 6.91175 2.5 5.16536 2.5 3.3737C2.5 3.1237 2.58333 2.91536 2.75 2.7487C2.91667 2.58203 3.125 2.4987 3.375 2.4987H6.75C6.94444 2.4987 7.11806 2.5612 7.27083 2.6862C7.42361 2.8112 7.51389 2.97092 7.54167 3.16536L8.08333 6.08203C8.11111 6.27648 8.10778 6.45342 8.07333 6.61286C8.03833 6.77286 7.95833 6.91536 7.83333 7.04036L5.83333 9.08203C6.41667 10.082 7.14583 11.0195 8.02083 11.8945C8.89583 12.7695 9.86111 13.5265 10.9167 14.1654L12.875 12.207C13 12.082 13.1633 11.9881 13.365 11.9254C13.5661 11.8631 13.7639 11.8459 13.9583 11.8737L16.8333 12.457C17.0278 12.4987 17.1875 12.5923 17.3125 12.7379C17.4375 12.884 17.5 13.0543 17.5 13.2487V16.6237C17.5 16.8737 17.4167 17.082 17.25 17.2487C17.0833 17.4154 16.875 17.4987 16.625 17.4987Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneInTalk);
export default __webpack_public_path__ + "static/media/phone-in-talk.d4ec22bd80341e479c61eb58a7b522cd.svg";
export { ForwardRef as ReactComponent };